<template>
    <form class="form-horizontal group-border-dashed" @submit.prevent="handleSubmit" novalidate>
        <div class="container p-0">
            <div class="form-group">
                <h3 class="wizard-title text-uppercase">Kundeninformation – Auftraggeber</h3>
            </div>

            <radio-checkbox horizontal inline name="gender" label="Anrede" :options="genderOptions" :required="!disabled" :disabled="disabled" v-model="formData.gender" :validation="$v.formData.gender"/>
            <text-field horizontal :required="!disabled" :disabled="disabled" label="Vorname" v-model="formData.firstname" :validation="$v.formData.firstname"/>
            <text-field horizontal :required="!disabled" :disabled="disabled" label="Name" v-model="formData.lastname" :validation="$v.formData.lastname"/>
            <text-field horizontal :disabled="disabled" label="Funktion" v-model="formData.position" :validation="$v.formData.position"/>
            <text-field horizontal :required="!disabled" :disabled="disabled" label="E-Mail" v-model="formData.email" :validation="$v.formData.email"/>
            <text-field horizontal :required="!disabled" :disabled="disabled" label="Telefon" v-model="formData.phone" :validation="$v.formData.phone"/>

            <be-form-group horizontal v-if="!disabled">
                <button class="btn btn-lg btn-secondary btn-space" type="button" @click.prevent="$emit('previous', formData)">zurück</button>
                <button class="btn btn-lg btn-primary btn-space wizard-next" type="submit">weiter</button>
            </be-form-group>
        </div>
    </form>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';

    import { phone } from '../../../validators';
    import exam from '../../../mixins/exam';

    export default {
        mixins: [exam],

        data: () => ({
            formData: {
                gender: '',
                firstname: '',
                lastname: '',
                position: '',
                email: '',
                phone: '',
            },
            genderOptions: [
                {
                    icon: 'female',
                    label: 'Frau',
                    value: 'f',
                },
                {
                    icon: 'male-alt',
                    label: 'Herr',
                    value: 'm',
                },
            ],
        }),

        validations: {
            formData: {
                gender: { required },
                firstname: { required },
                lastname: { required },
                position: { },
                email: { required, email },
                phone: { required, phone },
            },
        },
    };
</script>
